import { pxToRem, remToPx } from './size-utils'

export default function (_value?: string[], basePx = 16): [string, string] {
  const value = Array.isArray(_value) ? _value[0] : undefined
  return typeof value === 'string' && value.includes('rem')
    ? [remToPx(value, basePx), value]
    : typeof value === 'string' && value.includes('px')
      ? [value, pxToRem(value, basePx)]
      : [`${value}`, 'Not Supported']
}
